import Vue from 'vue'
import {
  getUsersQuery,
  getProfilesQuery,
  getProfileByIdQuery,
  getUserProfilesQuery,
  addUserMutation,
  updateUserMutation,
  updateUserPreferencesMutation,
  setPasswordMutation,
  createUserProfileMutation,
  updateUserProfileMutation,
  deleteUserProfileMutation,
  createProfileMutation,
  updateProfileMutation,
  deleteProfileMutation,
  getUserInvitesQuery,
  createUserInviteMutation,
  deleteUserInviteMutation,
  deleteUserOrganizationMutation,
  getUserByIdQuery
} from '~src/graphql/users.graphql'

import { assert } from 'chai'

export default {
  getAllUsers({ dispatch, state }) {
    return dispatch('getItems', {
      state,
      modelName: 'users',
      loader: 'users:get',
      orderBy: 'name',
      query: getUsersQuery,
      resultPath: 'users.nodes'
    })
  },
  getUserById({ state, dispatch }, id) {
    return dispatch('getItemById', {
      id,
      state,
      loader: 'user:get',
      modelName: 'selectedUser',
      query: getUserByIdQuery,
      resultPath: 'user',
      addTo: ['users'],
      useCache: false
    })
  },
  setSelectedUser({ state, commit }, user) {
    commit('SET_ITEM', {
      item: user,
      state,
      modelName: 'selectedUser'
    })
  },

  createUser({ dispatch, state }, user) {
    return dispatch('createItem', {
      item: user,
      state,
      loader: 'user:persist',
      mutation: addUserMutation,
      resultPath: 'addUser.uuid'
    }).then(useId => {
      return dispatch('getUserById', useId)
    })
  },

  updateUser({ dispatch, state }, user) {
    user.organizationId = Vue.currentOrganization.id

    return dispatch('updateItem', {
      item: user,
      state,
      addTo: ['users'],
      loader: 'user:persist',
      mutation: updateUserMutation,
      resultPath: 'updateUser.user'
    })
  },

  updateUserPreferences({ dispatch, state }, user) {
    return dispatch('updateItem', {
      item: user,
      state,
      addTo: ['users'],
      loader: 'user:persist',
      mutation: updateUserPreferencesMutation,
      resultPath: 'updateUser.user'
    })
  },

  setPassword({ dispatch, state }, payload) {
    return dispatch('createItem', {
      item: payload,
      state,
      loader: 'passowrd:set',
      mutation: setPasswordMutation,
      resultPath: 'boolean'
    })
  },

  // Profiles
  getAllProfiles({ dispatch, state }) {
    return dispatch('getItems', {
      state,
      modelName: 'profiles',
      loader: 'profiles:get',
      orderBy: 'name',
      query: getProfilesQuery,
      resultPath: 'profiles.nodes'
    })
  },
  getProfileById({ dispatch, state }, id) {
    return dispatch('getItemById', {
      id,
      state,
      loader: 'profile:get',
      modelName: 'selectedProfile',
      query: getProfileByIdQuery,
      resultPath: 'profile',
      addTo: ['profiles'],
      useCache: false
    })
  },
  createProfile({ dispatch, state }, userProfile) {
    return dispatch('createItem', {
      item: userProfile,
      state,
      addTo: ['profiles'],
      loader: 'profiles:persist',
      mutation: createProfileMutation,
      resultPath: 'createProfile.profile'
    })
  },
  updateProfile({ dispatch, state }, userGroup) {
    return dispatch('updateItem', {
      item: userGroup,
      state,
      addTo: ['profiles'],
      loader: 'profiles:persist',
      mutation: updateProfileMutation,
      resultPath: 'updateProfile.profile'
    })
  },
  deleteProfile({ dispatch, state }, userGroupId) {
    return dispatch('deleteItem', {
      id: userGroupId,
      state,
      removeFrom: ['profiles'],
      loader: 'profiles:delete',
      mutation: deleteProfileMutation
    })
  },

  // User Profiles
  getUserProfilesByUserId({ dispatch, state }, userId) {
    return dispatch('getItems', {
      state,
      modelName: 'userProfiles',
      loader: 'userProfiles:get',
      query: getUserProfilesQuery,
      resultPath: 'userProfiles.nodes',
      variables: {
        userId
      }
    })
  },
  createUserProfile({ dispatch, state }, userProfile) {
    return dispatch('createItem', {
      item: userProfile,
      state,
      addTo: ['userProfiles'],
      loader: 'userProfiles:persist',
      mutation: createUserProfileMutation,
      resultPath: 'createUserProfile.userProfile'
    })
  },
  updateUserProfile({ dispatch, state }, userGroup) {
    return dispatch('updateItem', {
      item: userGroup,
      state,
      addTo: ['userProfiles'],
      loader: 'userProfiles:persist',
      mutation: updateUserProfileMutation,
      resultPath: 'updateUserProfile.userProfile'
    })
  },
  deleteUserProfile({ dispatch, state }, userGroupId) {
    return dispatch('deleteItem', {
      id: userGroupId,
      state,
      removeFrom: ['userProfiles'],
      loader: 'userProfiles:delete',
      mutation: deleteUserProfileMutation
    })
  },

  deleteUserOrganization({ dispatch, state }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      loader: 'userOrganization:delete',
      mutation: deleteUserOrganizationMutation
    })
  },

  // Invites

  getAllInvites({ dispatch, state }) {
    return dispatch('getItems', {
      state,
      modelName: 'invites',
      loader: 'invites:get',
      query: getUserInvitesQuery,
      resultPath: 'userInvites.nodes'
    })
  },
  deleteInvite({ dispatch, state }, userGroupId) {
    return dispatch('deleteItem', {
      id: userGroupId,
      state,
      removeFrom: ['invites'],
      loader: 'invites:delete',
      mutation: deleteUserInviteMutation
    })
  },

  getInviteDetails({ dispatch, state }, token) {
    return dispatch('getItemById', {
      id: token,
      state,
      loader: 'invite:get',
      serverName: 'aramaki',
      modelName: 'inviteDetails'
      // endpoint: CONFIG.ARAMAKI.ENDPOINTS.ACCEPT_INVITE
    })
  },
  inviteUser({ dispatch, state }, payload) {
    assert.exists(payload.email)
    assert.exists(payload.role)

    const invite = {
      email: payload.email,
      role: payload.role
    }

    return dispatch('createItem', {
      item: invite,
      state,
      addTo: ['invites'],
      loader: 'invites:persist',
      mutation: createUserInviteMutation,
      resultPath: 'createInvite.userInvite'
    })
  }
}
